module.exports = __webpack_public_path__ + "img/practice-2.8218f5a7.jpg";